import { BorderBox, Box, Text } from '@trmediaab/zebra';

interface CardProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
  fillHeight?: boolean;
  header?: React.ReactNode;
  headerVariant?: 'default' | 'muted';
}

const Card = ({
  children,
  variant = 'primary',
  fillHeight = false,
  header,
  headerVariant = 'default',
}: CardProps) => {
  const borderColor =
    variant === 'primary' ? 'checkout.cardBorder' : 'transparent';
  return (
    <BorderBox
      border="1"
      bg={
        variant === 'primary'
          ? 'checkout.cardBgPrimary'
          : 'checkout.cardBgSecondary'
      }
      borderColor={borderColor}
      height={fillHeight ? '100%' : undefined}
    >
      {header != null && (
        <BorderBox
          display="flex"
          height={['buttonHeights.xlarge', null, 'buttonHeights.xxlarge']}
          alignItems="center"
          px="3"
          bg={
            headerVariant === 'muted'
              ? 'checkout.cardHeaderBgMuted'
              : 'checkout.cardHeaderBg'
          }
          color={
            headerVariant === 'muted'
              ? 'checkout.cardHeaderTextMuted'
              : 'checkout.cardHeaderText'
          }
          borderBottom="1"
          borderColor={borderColor}
        >
          {typeof header === 'string' ? (
            <Text fontWeight="bold">{header}</Text>
          ) : (
            header
          )}
        </BorderBox>
      )}
      <Box p="3">{children}</Box>
    </BorderBox>
  );
};

export default Card;
